import { useMemo } from 'react';

import { withDate } from '@lucid/utils';

import type { Lucid } from '../types/types';

type CollectionDataPageType =
  | Lucid.Directus.Generated.Ebook
  | Lucid.Directus.Generated.Webinar_2
  | Lucid.Directus.Generated.Case_Study
  | Lucid.Directus.Generated.Event;

const useSortedCollectionCards = (items: CollectionDataPageType[]) =>
  useMemo(
    () =>
      withDate.sortItems(items as Lucid.Date.Item<CollectionDataPageType>[], {
        direction: 'desc',
        dateSortField: 'date_created',
      }).sortedDates,
    [items],
  );

export default useSortedCollectionCards;
